import React, { useState, useEffect } from 'react';
import {
  Card,
  Select,
  Button,
  Table,
  Tag,
  Space,
  Input,
  message,
  Modal,
  Form,
  Row,
  Col,
  App
} from 'antd';
import {
  UserOutlined,
  ShopOutlined,
  SearchOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined
} from '@ant-design/icons';
import axios from 'axios';
import { BASE_URL } from '../../App';
import './bcs.css';

const { Option } = Select;
const { Search } = Input;

const DealerExecutiveMapping = () => {
  const [branches, setBranches] = useState([]);
  const [executives, setExecutives] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [levels, setLevels] = useState([]);
  const [mappings, setMappings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedExecutive, setSelectedExecutive] = useState(null);
  const [selectedDealers, setSelectedDealers] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [searchText, setSearchText] = useState('');
 const login_id = localStorage.getItem("LOGIN_ID");
 const userbranch_code = localStorage.getItem("BRANCH_CODE");
  // Fetch initial data
  useEffect(() => {
    fetchBranches();
    fetchLevels();
  }, []);

  const fetchBranches = async () => {
    try {
      const response = await axios.post(BASE_URL+'/bcsapproval_branch',{userbranch_code:userbranch_code});
      setBranches(response.data);
    } catch (error) {
      message.error('Failed to fetch branches');
    }
  };

  const fetchExecutives = async (branchCode) => {
    try {
      const response = await axios.post(BASE_URL+'/bcsapproval_executive',{branch:branchCode});
      setExecutives(response.data);
    } catch (error) {
      message.error('Failed to fetch executives');
    }
  };

  const fetchDealers = async (branchCode) => {
    try {
      const response = await axios.post(BASE_URL+'/bcsapproval_dealers',{branch:branchCode});
      setDealers(response.data);
    } catch (error) {
      message.error('Failed to fetch dealers');
    }
  };

  const fetchMappings = async (executiveId, branchCode) => {
    try {
      const response = await axios.post(BASE_URL+'/bcsapproval_getMappings',{executive:executiveId,branch:branchCode});
      setMappings(response.data);
    } catch (error) {
      message.error('Failed to fetch mappings');
    }
  };

  const fetchLevels = async () => {
    try {
      const response = await axios.post(BASE_URL+'/bcsapproval_getLevels',{userbranch_code:userbranch_code});
      setLevels(response.data);
    } catch (error) {
      message.error('Failed to fetch approval levels');
    }
  };

  const handleBranchChange = (value) => {
    setSelectedBranch(value);
    setSelectedExecutive(null);
    setSelectedDealers([]);
    setMappings([]);
    
    if (value) {
      fetchExecutives(value);
      fetchDealers(value);
    }
  };

  const handleExecutiveChange = (value) => {
    setSelectedExecutive(value);
    if (value && selectedBranch) {
      fetchMappings(value, selectedBranch);
    }
  };

  const handleMapDealers = async () => {
    if (!selectedBranch || !selectedExecutive || !selectedLevel || selectedDealers.length === 0) {
      message.error('Please select branch, executive, level, and at least one dealer');
      return;
    }

    setLoading(true);
    try {
      await axios.post(BASE_URL+'/bcsapproval_createMapping', {
        branch: selectedBranch,
        executive: selectedExecutive,
        dealers: selectedDealers,
        level: selectedLevel,
        createdBy: login_id
      });
      
      message.success('Mapping created successfully');
      setSelectedDealers([]);
      fetchMappings(selectedExecutive, selectedBranch);
    } catch (error) {
      message.error('Failed to create mapping');
    } finally {
      setLoading(false);
    }
  };

  const toggleStatus = async (mappingId, currentStatus) => {
    try {
      await axios.post(BASE_URL+'/bcsapproval_updateStatus',{
        mapid:mappingId,
        status: currentStatus === '1' ? '0' : '1',
        modifiedBy: login_id 
      });
      
      message.success('Status updated successfully');
      fetchMappings(selectedExecutive, selectedBranch);
    } catch (error) {
      message.error('Failed to update status');
    }
  };

  const deleteMapping = async (mappingId) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this mapping?',
      icon: <InfoCircleOutlined />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        try {
          await axios.post(BASE_URL+'/bcsapproval_deleteMapping',{mapid:mappingId});
          message.success('Mapping deleted successfully');
          fetchMappings(selectedExecutive, selectedBranch);
        } catch (error) {
          message.error('Failed to delete mapping');
        }
      }
    });
  };

 const filteredMappings = mappings.filter(mapping => {
  
  const executive = mapping.executiveLoginId || '';
  const dealer = mapping.dealerLoginId || '';
  const level = mapping.level ? mapping.level.toString() : '';
  const status = mapping.status || '';
  
  const search = searchText.toLowerCase();
  
  return (
    executive.toLowerCase().includes(search) ||
    dealer.toLowerCase().includes(search) ||
    level.includes(search) ||
    status.toLowerCase().includes(search)
  );
});

  const columns = [
    {
      title: 'Executive',
      dataIndex: 'ExecutiveLoginID',
      key: 'executiveLoginId',
    },
    {
      title: 'Dealer',
      dataIndex: 'DealerLoginID',
      key: 'dealerLoginId',
    },
    {
      title: 'Level',
      dataIndex: 'level',
      key: 'level',
      render: (level) => (
        <Tag color="blue" className="level-badge">
          {level === '1' ? 'Marketing Team Approval' : 'HO Approval'}
        </Tag>
      ),
    },
   {
  title: 'Status',
  dataIndex: 'Status',
  key: 'status',
  render: (status) => (
    <Tag 
      color={status === '1' ? 'green' : 'red'} // use valid color
      className="status-badge"
    >
      {status === '1' ? 'ACTIVE' : 'INACTIVE'} 
    </Tag>
  ),
},

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space size="middle">
          <Button 
            size="small"
            type={record.Searchtatus === '1' ? 'default' : 'primary'}
            icon={record.Status === '1' ? <CloseCircleOutlined /> : <CheckCircleOutlined />}
            onClick={() => toggleStatus(record.MappingID, record.Status)}
          >
            {record.Status === '1' ? 'Deactivate' : 'Activate'}
          </Button>
          <Button 
            size="small" 
            danger 
            onClick={() => deleteMapping(record.MappingID)}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="dealer-executive-mapping">
      <Card 
        title={
          <span>
            <UserOutlined /> BCS Approval Mapping
          </span>
        }
        className="mapping-card"
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Branch">
              <Select
                placeholder="Select branch(es)"
                value={selectedBranch}
                onChange={handleBranchChange}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {branches.map(branch => (
                  <Option key={branch.value} value={branch.value}>
                    {branch.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Executive">
              <Select
                placeholder="Select executive(s)"
                value={selectedExecutive}
                onChange={handleExecutiveChange}
                allowClear
                showSearch
                disabled={!selectedBranch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {executives.map(executive => (
                  <Option key={executive.value} value={executive.value}>
                    {executive.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Approval Level">
              <Select
                placeholder="Select level"
                value={selectedLevel}
                onChange={setSelectedLevel}
                allowClear
              >
                {levels.map(level => (
                  <Option key={level.value} value={level.value}>
                    {level.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        
        <Row gutter={16}>
          <Col span={20}>
            <Form.Item label="Dealers">
              <Select
                mode="multiple"
                placeholder="Select dealer(s)"
                value={selectedDealers}
                onChange={setSelectedDealers}
                allowClear
                disabled={!selectedBranch}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {dealers.map(dealer => (
                  <Option key={dealer.value} value={dealer.value}>
                    {dealer.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Button 
              type="primary" 
              onClick={handleMapDealers}
              loading={loading}
              style={{ marginTop: '30px', width: '100%' }}
            >
              Map Selected Dealers
            </Button>
          </Col>
        </Row>
      </Card>
      
      <Card 
        title={
          <span>
            <ShopOutlined /> Current Mappings
          </span>
        }
        className="mappings-card"
        extra={
          <Search
            placeholder="Search mappings..."
            allowClear
            onSearch={setSearchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 250 }}
          />
        }
      >
        <Table
          columns={columns}
          dataSource={filteredMappings}
          rowKey="mappingId"
          size="small"
          pagination={{ pageSize: 10 }}
          locale={{
            emptyText: (
              <div className="empty-table">
                <InfoCircleOutlined />
                <span>No dealer-executive mappings found.</span>
              </div>
            )
          }}
        />
      </Card>
    </div>
  );
};

export default DealerExecutiveMapping;